import { render, staticRenderFns } from "./AdminDashboardTopPoliciesVisited.vue?vue&type=template&id=184add7a&"
import script from "./AdminDashboardTopPoliciesVisited.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardTopPoliciesVisited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports